import { useState, useEffect } from "react";

const API = "https://prestijcrm.duckdns.org/api";

const PLATFORMS = [
  { key: "instagram", label: "Instagram", color: "#e1306c" },
  { key: "facebook", label: "Facebook", color: "#1877f2" },
  { key: "tiktok", label: "TikTok", color: "#25f4ee" },
 { key: "youtube", label: "YouTube", color: "#ff0000" },
];

function Panel({ platform, token }) {
  const [accounts, setAccounts] = useState([]);
  const [label, setLabel] = useState("");
  const [loading, setLoading] = useState(false);

  const h = { Authorization: `Bearer ${token}` };

  const load = () => {
    fetch(`${API}/${platform.key}/accounts`, { headers: h })
      .then((r) => r.json())
      .then((d) => setAccounts(Array.isArray(d) ? d : []))
      .catch(() => {});
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const connect = () => {
    if (!label.trim()) {
      alert("Önce bir etiket/isim gir (örn. Prestij Emlak)");
      return;
    }
    setLoading(true);
    fetch(`${API}/${platform.key}/auth-url?label=${encodeURIComponent(label)}`, { headers: h })
      .then((r) => r.json())
      .then((d) => {
        setLoading(false);
        if (d.url) window.open(d.url, "_blank");
        else alert("Bağlantı linki alınamadı");
      })
      .catch(() => setLoading(false));
  };

  return (
    <div style={{ background: "#1e293b", borderRadius: 10, padding: 24, flex: 1, minWidth: 320 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <div style={{ width: 10, height: 10, borderRadius: 5, background: platform.color }} />
        <div style={{ fontSize: 18, fontWeight: 700 }}>{platform.label}</div>
      </div>
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <input
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="Etiket (örn. Prestij Emlak)"
          style={{
            flex: 1,
            padding: "8px 12px",
            borderRadius: 6,
            border: "1px solid #334155",
            background: "#0f172a",
            color: "#fff",
            fontSize: 14,
          }}
        />
        <button
          onClick={connect}
          disabled={loading}
          style={{
            background: platform.color,
            color: "#0f172a",
            border: "none",
            borderRadius: 6,
            padding: "8px 16px",
            cursor: "pointer",
            fontSize: 14,
            fontWeight: 700,
            whiteSpace: "nowrap",
          }}
        >
          {loading ? "..." : "+ Hesap Bağla"}
        </button>
      </div>
      {accounts.length === 0 ? (
        <div style={{ color: "#94a3b8", fontSize: 14 }}>Henüz bağlı hesap yok.</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {accounts.map((a) => (
            <div
              key={a.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "#0f172a",
                borderRadius: 6,
                padding: "8px 12px",
              }}
            >
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{a.account_name}</div>
                <div style={{ color: "#94a3b8", fontSize: 12 }}>{a.label}</div>
              </div>
              <button
                onClick={load}
                style={{ background: "transparent", color: "#3b82f6", border: "none", cursor: "pointer", fontSize: 12 }}
              >
                Yenile
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function SosyalMedya() {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams(window.location.search);
  const connected =
    params.get("instagram_connected") || params.get("facebook_connected") || params.get("tiktok_connected") || params.get("youtube_connected");
  const error = params.get("instagram_error") || params.get("facebook_error") || params.get("tiktok_error") || params.get("youtube_error");

  return (
    <div style={{ padding: 32, color: "white" }}>
      <h2 style={{ marginBottom: 24, fontSize: 22 }}>Sosyal Medya Hesapları</h2>
      {connected && (
        <div
          style={{ background: "#10b981", color: "#fff", padding: "10px 16px", borderRadius: 6, marginBottom: 16, fontSize: 14 }}
        >
          ✓ Bağlandı: {decodeURIComponent(connected)}
        </div>
      )}
      {error && (
        <div
          style={{ background: "#ef4444", color: "#fff", padding: "10px 16px", borderRadius: 6, marginBottom: 16, fontSize: 14 }}
        >
          ✗ Hata: {decodeURIComponent(error)}
        </div>
      )}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        {PLATFORMS.map((p) => (
          <Panel key={p.key} platform={p} token={token} />
        ))}
      </div>
    </div>
  );
}
